"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCandyMachine = void 0;
const mpl_toolbox_1 = require("@metaplex-foundation/mpl-toolbox");
const umi_1 = require("@metaplex-foundation/umi");
const generated_1 = require("./generated");
const hooked_1 = require("./hooked");
const createCandyMachine = async (context, input) => {
    const space = (0, hooked_1.getCandyMachineSize)(input.itemsAvailable, input.configLineSettings ?? (0, umi_1.none)());
    const lamports = await context.rpc.getRent(space);
    return (0, umi_1.transactionBuilder)()
        .add((0, mpl_toolbox_1.createAccount)(context, {
        newAccount: input.candyMachine,
        lamports,
        space,
        programId: context.programs.get('mplCandyMachineCore').publicKey,
    }))
        .add((0, generated_1.initializeCandyMachine)(context, {
        ...input,
        candyMachine: input.candyMachine.publicKey,
    }));
};
exports.createCandyMachine = createCandyMachine;
//# sourceMappingURL=createCandyMachine.js.map